(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const running = new Map();
  const clear = (button) => {
    const effect = running.get(button);
    if (!effect) return;
    effect.animation.cancel();
    effect.ripple.remove();
    running.delete(button);
  };
  preference.addEventListener('change', () => {
    if (preference.matches) [...running.keys()].forEach(clear);
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.button');
    if (!button || preference.matches || button.disabled || button.getAttribute('aria-disabled') === 'true' || button.classList.contains('is-loading') || !Element.prototype.animate) return;
    clear(button);
    const bounds = button.getBoundingClientRect();
    const diameter = Math.hypot(bounds.width, bounds.height) * 2;
    const ripple = document.createElement('span');
    ripple.className = 'brand-click-ripple';
    ripple.setAttribute('aria-hidden', 'true');
    const pointer = event.detail > 0;
    const x = pointer ? event.clientX - bounds.left : bounds.width / 2;
    const y = pointer ? event.clientY - bounds.top : bounds.height / 2;
    Object.assign(ripple.style, { width: `${diameter}px`, height: `${diameter}px`, left: `${x - diameter / 2}px`, top: `${y - diameter / 2}px` });
    button.append(ripple);
    const animation = ripple.animate([
      { transform: 'scale(0)', opacity: .16 },
      { transform: 'scale(1)', opacity: 0 }
    ], { duration: 480, easing: 'cubic-bezier(.22,1,.36,1)' });
    running.set(button, { ripple, animation });
    const finish = () => {
      ripple.remove();
      if (running.get(button)?.ripple === ripple) running.delete(button);
    };
    animation.finished.then(finish, finish);
  });
})();
